import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "./notification-service";
import { ENV } from "@env/environment";

import 'rxjs/Rx';
import * as moment from "moment";
import { Subject } from "rxjs";

@Injectable()
export class DataService {

  public settings: any;
  public model_attribute_options: any;
  public current_user: any = {};
  public current_company: any = [];
  public current_buildings: any = [];
  public settings_service: any = {};
  public service_visits: any = {};
  public onCompanyUpdate = new Subject<any>();

  constructor(public storage: Storage,
    public httpClient: HttpClient,
    public notification: NotificationService) {
  }

  dateToISO(date: any) {
    return moment(date).toISOString();
  }

  checkObjectEmpty(object: Object, key_name: string): boolean {
    for (let key in object) {
      if (object[key].length > 0 && key_name == key) {
        return false;
      }
    }
    return true;
  }

  initLocalDataServerInfo(type: string = 'branch', company_id: number = 0, next_action: any = () => { }): void {
    this.notification.showLoading('loading_settings_data', 'bubbles', true, () => {
      this.initSettings(type, company_id, () => {
        this.initModelAttributeOptions(company_id, 'service', 'severity', 'severity', () => {
          this.initModelAttributeOptions(company_id, 'service', 'data', 'cause', () => {
            this.initModelAttributeOptions(company_id, 'service', 'service_type', 'service_type', () => {
              this.initModelAttributeOptions(company_id, 'service_visit', 'data', 'risk_assessment', () => {
                this.initModelAttributeOptions(company_id, 'service', 'discipline', 'service_discipline', () => {
                  this.initModelAttributeOptions(company_id, 'audit', 'data', 'audit_questions', () => {
                    this.initModelAttributeOptions(company_id, 'asset', 'category', 'asset_category', () => {
                      this.initModelAttributeOptions(company_id, 'service', 'status', 'service_status', () => {
                        this.initModelAttributeOptions(company_id, 'asset', 'data', 'compliant_status', () => {
                          this.readLocalData('current_user').then(() => this.notification.hideLoading(() => {
                            next_action();
                          }));
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  initSettings(type: string = 'branch', company_id: number = 0, next_action: any = () => {
  }) {
    this.storage.get('settings').then((data) => {
      if (data == null || !data.hasOwnProperty('server_version')) {
        let url = this.settings.server_api_url + '/settings/read';
        this.httpClient.post(url, {
          type: type,
          company_id: company_id
        }, {
          headers: { 'Content-Type': 'application/json' },
        }).map(
          (response: Response) => response
        ).finally(
          () => next_action()
        ).subscribe(
          (response) => {
            if (response !== null && Object.keys(response).length > 0 && response[0].hasOwnProperty('id')) {
              for (let setting of Object.keys(response).map(e => response[e])) {
                if (setting['option_value'] == null || setting['option_value'] == '') {
                  this.settings[setting['option_name']] = setting['data'];
                } else {
                  this.settings[setting['option_name']] = setting['option_value'];
                }
              }
              this.storage.set('settings', this.settings).then(() => this.readLocalData('settings'));
            } else {
              this.notification.showAlert('failed', 'alert_read_settings_failed', 'ok', true);
            }
          },
          error => {
            this.notification.showAlert('failed', 'alert_read_settings_failed', 'ok', true);
          }
        );
      } else {
        this.readLocalData('settings').then(next_action());
      }
    });
  }

  initModelAttributeOptions(company_id: number = 0, for_model: string, for_attribute: string, option_name: string, next_action: any = () => {
  }) {
    this.storage.get('model_attribute_options').then((data) => {
      if (this.checkObjectEmpty(data, option_name)) {
        let url = this.settings.server_api_url + '/model-attribute-options/read';
        this.httpClient.post(url, {
          company_id: company_id,
          for_model: for_model,
          for_attribute: for_attribute,
          option_name: option_name
        }, {
          headers: { 'Content-Type': 'application/json' },
        }).map(
          (response: Response) => response
        ).finally(
          () => next_action()
        ).subscribe(
          (response) => {
            if (response !== null && Object.keys(response).length > 0 && response[0].hasOwnProperty('id')) {
              let new_model_attribute_options = {};
              for (let model_attribute_option of Object.keys(response).map(e => response[e])) {
                if (!new_model_attribute_options.hasOwnProperty(model_attribute_option['option_name'])) {
                  new_model_attribute_options[model_attribute_option['option_name']] = [];
                }
                if (model_attribute_option['option_value'] !== null && model_attribute_option['option_value'] !== '') {
                  new_model_attribute_options[model_attribute_option['option_name']].push(model_attribute_option['option_value'])
                } else {
                  new_model_attribute_options[model_attribute_option['option_name']].push(model_attribute_option['data'])
                }
              }
              for (let key in new_model_attribute_options) {
                this.model_attribute_options[key] = new_model_attribute_options[key];
              }
              this.storage.set('model_attribute_options', this.model_attribute_options).then(() => this.readLocalData('model_attribute_options'));
            } else {
              this.notification.showToast('alert_read_model_attribute_option_failed', true);
            }
          },
          error => {
            this.notification.showToast('alert_read_model_attribute_option_failed', true);
          }
        );
      } else {
        this.readLocalData('model_attribute_options').then(next_action());
      }
    });
  }

  readLocalData(local_key: string = 'all') {
    return this.storage.forEach((value, key, index) => {
      if (local_key == 'all' || local_key == key) {
        this[key] = value;
      }
    }).then(() => {
      if (!this.settings) {
        this.settings = {
          server_api_url: ENV.SERVER_API_URL
        };
        this.storage.set('settings', this.settings).then();
      }

      if (!this.model_attribute_options) {
        this.model_attribute_options = {
          cause: [],
          service_type: [],
          severity: [],
          asset_category: [],
          service_status: [],
          audit_questions: [],
          risk_assessment: [],
          service_discipline: [],
        };
        this.storage.set('model_attribute_options', this.model_attribute_options).then();
      }

      if (!this.settings_service.hasOwnProperty('days_before')) {
        this.settings_service.days_before = 180;
        this.settings_service.days_after = 180;
        this.storage.set('settings_service', this.settings_service).then();
      }
    });
  }

  removeItem(items, item) {
    let index = items.indexOf(item);
    items.splice(index, 1);
  };

  isDataUrl(data_url: any) {
    if (typeof data_url == 'string') {
      return !!data_url.match(/^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i);
    }
  }

  isDataUrlImage(data_url: any) {
    if (typeof data_url == 'string') {
      return !!data_url.match(/^\s*data:image\/([a-z\-]+)(;base64),[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i);
    }
  }

  saveLocalSetting() {
    this.storage.set('settings', this.settings).then();
  }
}



// WEBPACK FOOTER //
// ./src/services/data-service.ts